<template>
    <div class="the-blank" :class="{'blank-sp': $store.state.screen == 1}">
        <img src="~images/blank.png" />
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    // 横屏css
    .the-blank {
        img {
            width: 460px;
            height: 460px;
        }
    }
    // 竖屏css
    .blank-sp {
        img {
            width: 700px;
            height: 700px;
        }
    }
</style>